import React, { Component } from 'react';
import { connect } from 'react-redux';
import {removeNote} from '../actions';

class Note extends Component {
	constructor(props) {
		super(props);
		this.state = props;
	}
	removeNoteClicked() {
		const {dispatch} = this.props;
		console.log('Remove?');
		dispatch(removeNote(this.props.note.note_id));
	}
	render() {
		let state = this.state,
			note = this.props.note,
			isRemoving = state.notes.find(stateNote => stateNote.note_id === note.note_id).isRemoving;
		let noteClass = isRemoving ? 'webnotes_note webnotes_waiting' : 'webnotes_note';
		return (
			<div className={noteClass} data-note_id={note.note_id} data-note_viewport_width={note.context.viewport_width} style={{left: +note.context.left,top: +note.context.top}}><button className="webnotes_note-delete" onClick={this.removeNoteClicked.bind(this)}>X</button><p><strong>{note.title}</strong></p><p>{note.text}</p><p>{this.props.annotator}: {note.author}</p><div className="webnotes_note-error"></div></div>
		)
	}
}

const mapStateToProps = state => state;
export default connect(mapStateToProps)(Note);


// WEBPACK FOOTER //
// ./src/js/components/Note.js